module.exports = __webpack_public_path__ + "static/Apercu-Regular-3839022b76a99f5b7a9fb79f3c67b579.woff2";